var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/6341/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es6.typed.data-view.js
// module id = 246
// module chunks = 0